

export default class SideNacAccordion {
    
    static get selector() {
        return '.sideNav__item--accordion';
    }

    constructor(el) {
        this.el = el;
        this.isActive = false;
        this.title = this.el.querySelector('.sideNav__itemTitle');
        this.setEvents();
    }

    toggle() {
        this.el.classList.toggle('sideNav__item--accordionOpen')
    }

    setEvents() {
        this.el.addEventListener('click', this.e_click.bind(this) );
    }

    e_click(e) {
        e.preventDefault();
        this.toggle();
    }
}